import React from 'react';
import { Button } from '@kontentino/ui';
import Modal from 'components/shared/Modal';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  confirmVariant?: 'primary' | 'danger';
  isConfirming?: boolean;
  dataCyPrefix: string;
  onConfirm: () => void;
  onClose: () => void;
  children?: React.ReactNode;
}

const ConfirmDialog = ({
  isOpen,
  title,
  message,
  confirmLabel,
  cancelLabel,
  confirmVariant = 'primary',
  isConfirming = false,
  dataCyPrefix,
  onConfirm,
  onClose,
  children,
}: ConfirmDialogProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      dataCy={{
        wrapper: `${dataCyPrefix}_dialog`,
        closeButton: `${dataCyPrefix}_close`,
      }}
    >
      <Modal.Header title={title} />
      <Modal.Content>
        <p className="tw-text-sm tw-text-grayscale-180">{message}</p>
        {children}
      </Modal.Content>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onClose}
          disabled={isConfirming}
          data-cy={`${dataCyPrefix}_cancel`}
        >
          {cancelLabel}
        </Button>
        <Button
          variant={confirmVariant}
          onClick={onConfirm}
          isLoading={isConfirming}
          disabled={isConfirming}
          data-cy={`${dataCyPrefix}_confirm`}
        >
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDialog;
